import { render, staticRenderFns } from "./shebao_geren.vue?vue&type=template&id=812404b0&scoped=true"
import script from "./shebao_geren.vue?vue&type=script&lang=js"
export * from "./shebao_geren.vue?vue&type=script&lang=js"
import style0 from "./shebao_geren.vue?vue&type=style&index=0&id=812404b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812404b0",
  null
  
)

export default component.exports